import { ControlledCustomSelect } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { useIsMobile } from '@sravni/react-utils';

import { useDictionaries } from 'entities/creditForm';

export const NumberOfDependents: FC<IFieldFactoryProps> = (props) => {
  const isMobile = useIsMobile();

  const { numberOfDependentsTypes } = useDictionaries(['numberOfDependentsTypes']);
  const { type, ...other } = props;

  return (
    <ControlledCustomSelect
      {...other}
      name={type}
      options={numberOfDependentsTypes}
      withCrossIcon={false}
      mobile={isMobile}
    />
  );
};
